import { createContext } from 'react';

import { SearchCriteria } from '../../../../js/@types/SearchCriteria';
import { SearchFilters } from '../../../../js/@types/SearchFilters';

export interface SearchFilterContextData {
    data: SearchFilters;
    criteria: SearchCriteria;
}

export const SearchFilterContext = createContext<SearchFilterContextData>(null);
